import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'timeAgo',
    standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
    constructor(private translate: TranslateService) { }

    transform(value: Date | string | number): string {
        if (!value) return this.translate.instant('time_ago.invalid_date');

        const now = new Date();
        const inputDate = new Date(value);
        const diffInSeconds = Math.floor((now.getTime() - inputDate.getTime()) / 1000);

        if (diffInSeconds < 60) {
            return this.getPluralizedString('time_ago.seconds', diffInSeconds);
        } else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return this.getPluralizedString('time_ago.minutes', minutes);
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return this.getPluralizedString('time_ago.hours', hours);
        } else if (diffInSeconds < 2592000) {
            const days = Math.floor(diffInSeconds / 86400);
            return this.getPluralizedString('time_ago.days', days);
        } else if (diffInSeconds < 31536000) {
            const months = Math.floor(diffInSeconds / 2592000);
            return this.getPluralizedString('time_ago.months', months);
        } else {
            const years = Math.floor(diffInSeconds / 31536000);
            return this.getPluralizedString('time_ago.years', years);
        }
    }

    private getPluralizedString(key: string, count: number): string {
        const translation = this.translate.instant(key);
        const pluralized = count === 1 ? translation.replace('{{count}}', count.toString()).replace('{{s}}', '') : translation.replace('{{count}}', count.toString()).replace('{{s}}', 's');
        return pluralized;
    }
}